module.exports = __webpack_public_path__ + "5942-shadow.3367717e2759a04ee6324afe199d48a6.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5942-shadow.png
// module id = 188
// module chunks = 0